<template>
  <v-container class="mt-5" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1">Tickets</span>
            <v-spacer></v-spacer>
            <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportar()">
              <v-icon>mdi-microsoft-excel</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              @click="initialize"
              small
              rounded
            >
              Actualizar
            </v-btn>
          </v-card-title>

          <v-card-actions>
            <v-row justify="end">
              <v-col cols="12" md="6" lg="4">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="usuario"
                  :items="usuariosTickets"
                  label="Selecciona un usuario"
                  persistent-hint
                  prepend-inner-icon="mdi-account"
                  hide-details
                  item-text="nombre_completo"
                  item-value="nombre_completo"
                >
                </v-autocomplete>
              </v-col>
              
              <v-col cols="12" md="6" lg="4">
                <v-text-field
                  label="Buscar"
                  v-model="search"
                  id="id"
                  hide-details
                  filled
                  dense
                  append-icon="mdi-magnify"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-radio-group
                  v-model="estatusFiltro"
                  row
                  dense
                  hide-details
                  small
                >
                  <v-radio
                    color="orange"
                    label="Abierto"
                    :value="1"
                  ></v-radio>
                  <v-radio
                    color="blue"
                    label="Asignado"
                    :value="2"
                  ></v-radio>
                  <v-radio
                    color="red"
                    label="Pendiente"
                    :value="3"
                  ></v-radio>
                  <v-radio
                    color="grey"
                    label="Revisión"
                    :value="4"
                  ></v-radio>
                  <v-radio
                    color="green"
                    label="Respondido"
                    :value="5"
                  ></v-radio>
                  <v-radio
                    color="yellow"
                    label="Cerrado"
                    :value="6"
                  ></v-radio>
                  <v-radio
                    color="black"
                    label="Rechazado"
                    :value="7"
                  ></v-radio>
                  <v-radio
                    label="Todos"
                    :value="8"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-card-actions>

          <v-card-actions>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="filterTickets"
                  sort-by="calories"
                  class="elevation-0"
                  :search="search"
                  item-key="name"
                  fixed-header
                  :height="tamanioPantalla"
                  dense
                  multi-sort
                >
                  <template v-slot:item.estatus="{ item }">
                    <v-chip small :color="getColor(item.estatus)" dark v-if="item.estatus==1"> Abierto </v-chip>
                    <v-chip small :color="getColor(item.estatus)" dark v-if="item.estatus==2"> Asignado </v-chip>
                    <v-chip small :color="getColor(item.estatus)" dark v-if="item.estatus==3"> Pendiente </v-chip>
                    <v-chip small color="grey"   dark v-if="item.estatus==4"> Revisión </v-chip>
                    <v-chip small color="green"  dark v-if="item.estatus==5"> Respondido </v-chip>
                    <v-chip small color="yellow"      v-if="item.estatus==6"> Cerrado </v-chip>
                    <v-chip small color="black"  dark v-if="item.estatus==7"> Rechazado </v-chip>
                  </template>

                  <template v-slot:item.id_unidad_negocio="{ item }">
                    <v-chip small v-if="item.id_unidad_negocio==1" color="#2EDAD5"> INBI </v-chip>
                    <v-chip small v-else color="#000D4A" dark> FAST </v-chip>
                  </template>

                  <template v-slot:item.visorrh="{ item }">
                    <v-checkbox small dense hide-details v-model="item.visorrh" @click="updateVisorRh(item)"></v-checkbox>
                  </template>

                  <template v-slot:item.historial="{ item }">
                    <v-btn color="primary" small rounded @click="historialTicket(item)" icon><v-icon>mdi-file-document</v-icon></v-btn>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn color="success" small rounded @click="verMotivo(item)" v-if="!item.nombre_jefe">Asignar</v-btn>
                  </template>
                  <template v-slot:no-data>
                    <v-btn
                      color="primary"
                      @click="initialize"
                      rounded
                      small
                    >
                      Reset
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Asignar ticket -->
    <v-dialog
      v-model="dialog"
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>

              <v-col cols="12">
                <v-textarea outlined v-model="ticket.motivo" label="Motivo de tu ticket" hide-details readonly></v-textarea>
              </v-col>

              <v-col cols="12" md="6">
                <v-autocomplete
                  outlined
                  dense
                  :items="areas"
                  v-model="area"
                  label="Selecciona departamento"
                  return-object
                  item-value="iddepartamento"
                  item-text="departamento"
                ></v-autocomplete>

                <v-autocomplete
                  outlined
                  dense
                  :items="puestos"
                  v-model="puesto"
                  label="Selecciona un puesto"
                  return-object
                  item-value="idpuesto"
                  item-text="puesto"
                ></v-autocomplete>

                <v-autocomplete
                  outlined
                  dense
                  :items="jefes"
                  v-model="jefe"
                  label="Selecciona un jefe"
                  return-object
                  item-value="id_usuario"
                  item-text="nombre_completo"
                ></v-autocomplete>

                <v-checkbox 
                  small
                  hide-details 
                  v-model="ticket.visorrh" 
                  @click="updateVisorRh(ticket)"
                  label="Generar copia para RH"
                ></v-checkbox>
                
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6" lg="4" v-for="(img, i) in ticket.evidencias" :key="i">
                <v-card class="py-4 shadowCard">
                  <v-img :src="url + img.foto" contain aspect-ratio="2"></v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="red"
            dark
            rounded
            small
            @click="abrirRechazar"
          >
            Rechazar
          </v-btn>

          <v-spacer></v-spacer>
          <v-btn
            color="black"
            dark
            rounded
            small
            @click="dialog=false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            rounded
            small
            dark
            @click="save"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Historial del ticket -->
    <v-dialog
      v-model="dialogHistorial"
      max-width="1000px"
      >
      <v-card>
        <v-card-title>
          <span class="headline">Historial</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" v-for="(respuestas, i) in historial" :key="i">
                <div>Folio: {{ ticket.idticket }}</div>
                <div>Fecha: {{ respuestas.fecha }}</div>
                <div v-if="respuestas.estatus==1">RESPONDIDO</div>
                <div v-else>SIN RESPONDER</div><br/>
                <v-textarea rows="3" auto-grow outlined v-model="respuestas.motivo" label="Motivo de tu ticket" readonly></v-textarea>

                <!-- chip para el nombre del que lo contesto -->
                <v-chip small dense hide-details>
                  Respondió: <strong> {{ respuestas.jefe }} </strong> 
                </v-chip>

                <v-textarea 
                  class="mt-3"
                  rows="3" 
                  auto-grow
                  outlined 
                  v-model="respuestas.respuesta" 
                  label="Solución" 
                  v-if="ver==false" 
                  readonly
                ></v-textarea>

                <v-row>
                  <v-col cols="12" md="6" lg="4" v-for="(img, i) in respuestas.evidencias" :key="i">
                    <v-card class="py-4 shadowCard">
                      <v-img :src="url + img.foto" contain aspect-ratio="2"></v-img>
                    </v-card>
                  </v-col>
                </v-row>

              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialogHistorial=false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para responder -->
    <v-dialog
      v-model="dialogResponder"
      max-width="900px"
      >
      <v-card>
        <v-card-title>
          <span class="headline">Responder Ticket</span>
        </v-card-title>

        <v-card-text v-for="(respuestas, i) in historial" :key="i"  v-if="respuestas.estatus==0">
          <div>Folio: {{ ticket.idticket }}</div>
          <div>Fecha: {{ respuestas.fecha }}</div>
          <div v-if="respuestas.estatus==1">RESPONDIDO</div>
          <div v-else>SIN RESPONDER</div><br/>
          <v-textarea rows="3" outlined v-model="respuestas.motivo" label="Motivo de tu ticket" readonly></v-textarea>
          <v-textarea rows="3" outlined v-model="respuesta" label="Solución"></v-textarea>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="black"
              dark
              small
              rounded
              @click="dialogResponder=false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              dark
              small
              rounded
              @click="saveRespuesta(respuestas)"
              v-if="ver==false"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card-text>

      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  import funcionesExcel  from '@/mixins/funcionesExcel'
  import validarErrores  from '@/mixins/validarErrores'
  
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/Loader.vue';


  export default {
    components:{
      Alerta,
      carga,
    },

    mixins: [ funcionesExcel, validarErrores ],
    
    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialogRechazo:false,
      motivoRechazo:'',

      longitud:10,
      search:'',
      respuesta:'',
      ver:false,
      dialogResponder: false,
      historial:{},
      dialogHistorial:false,
      ticket:{},

      areas:[],
      area: null,

      puestos:[],
      puesto:null,

      jefes:[],
      jefe: null,

      dialog: false,
      headers: [
        { text: 'Folio',             value: 'idticket', },
        { text: 'Usuario',           value: 'nombre_completo' },
        { text: 'Escuela',           value: 'id_unidad_negocio' },
        { text: 'Sucursal',          value: 'plantel' },
        { text: 'Fecha de creación', value: 'fecha_apertura' },
        { text: 'Resuelto en:',      value: 'fecha_asignacion' },
        { text: 'Estatus',           value: 'estatus' },
        { text: 'Area',              value: 'area' },
        { text: 'Encargado',         value: 'nombre_jefe' },
        { text: 'Auxiliar',          value: 'nombre_auxiliar' },
        { text: 'Visor RH',          value: 'visorrh'},
        { text: 'Actions',           value: 'actions', sortable: false },
        { text: 'Historial',         value: 'historial', sortable: false },
      ],
      tickets: [],
      estatusFiltro:8,
      usuariosTickets:[],
      usuario: null,
      url:'',
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar ticket' : 'Asignar Ticket'
      },

      tamanioPantalla () {
        return this.$vuetify.breakpoint.height - 350
      },

      filterTickets () {
        const tickets = this.tickets
        if(tickets){
          return tickets.filter((ticket)=>{
            var est = ticket.estatus;

            if( this.usuario ){
              if(ticket.nombre_jefe == this.usuario || ticket.nombre_auxiliar == this.usuario){
                if(this.estatusFiltro == 8){
                  return true
                }else{
                  if(est == this.estatusFiltro){return true}
                }
              }
            }else{
              if(this.estatusFiltro == 8){
                return true
              }else{
                if(est == this.estatusFiltro){return true}
              }
            }
          })
        }
      },

    },

    watch: {
      area(){
        this.puestos = this.area.puestos
      },

      puesto(){
        this.jefes = this.puesto.jefes
      }
    },

    async created () {
      this.url = 'https://web-back-inbi.club/kpi/evidencia-tickets/'
      this.cargar = true
      await this.initialize()
      await this.getAreas()
    },

    methods: {
      getAreas () {
        this.cargar = true
        this.tickets = []
        this.$http.get('departamentos.tickets').then(response=>{
          this.areas = response.body
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      initialize () {
        this.cargar = true
        this.tickets = []
        this.$http.get('tickets.all').then(response=>{
          this.longitud = response.body.length

          this.tickets = response.body
          for(const i in this.tickets){

            var msegMinuto = 1000 * 60; //Calcular minutos
            var msegHora = msegMinuto * 60; //Calcular Horas
            var msegDia = msegHora * 24; //Calcular Dias

            var tiempo = "";
            var dias = "";
            var horas = "";
            var minutos = "";

            if(this.tickets[i].estatus == 1){
              this.tickets[i].fecha_asignacion = "El ticket aun no ha sido asignado";
            } else if(this.tickets[i].estatus == 2 || this.tickets[i].estatus == 3 || this.tickets[i].estatus == 4 || this.tickets[i].estatus == 5 || this.tickets[i].estatus == 7){
              var fecha_asignacion_aux = new Date(this.tickets[i].fecha_asignado); //Calcula la fecha asignada
              var hoy = new Date(); //Calcula el dia de hoy
              hoy.setMonth(); //Obtiene mes
              hoy.setDate(); //Ontiene dia
              hoy.setHours(); //Obtiene las horas
              tiempo = new Date() - fecha_asignacion_aux;
              //calcular dias 
              dias = Math.floor(tiempo / msegDia)
              tiempo = tiempo - (dias * msegDia)
              //calcula horas
              horas = Math.floor(tiempo / msegHora)
              tiempo = tiempo - (horas * msegHora)
              //Calcula minutos
              minutos = Math.floor(tiempo /msegMinuto)
              tiempo = tiempo - (minutos * msegMinuto)
              //Muestra en la tabla
              this.tickets[i].fecha_asignacion = dias + " días, " + horas +" horas, y "+  minutos + " minutos";
            } else if(this.tickets[i].estatus == 6){
              var fecha_asignacion_aux = new Date(this.tickets[i].fecha_asignado); //Calcula la fecha asignada
              var hoy = new Date(); //Calcula el dia de hoy
              hoy.setMonth(); //Obtiene mes
              hoy.setDate(); //Ontiene dia
              hoy.setHours(); //Obtiene las horas
              tiempo = new Date(this.tickets[i].fecha_cierre) - fecha_asignacion_aux;
              //calcular dias 
              dias = Math.floor(tiempo / msegDia)
              tiempo = tiempo - (dias * msegDia)
              //calcula horas
              horas = Math.floor(tiempo / msegHora)
              tiempo = tiempo - (horas * msegHora)
              //Calcula minutos
              minutos = Math.floor(tiempo /msegMinuto)
              tiempo = tiempo - (minutos * msegMinuto)
              //Muestra en la tabla
              this.tickets[i].fecha_asignacion = dias + " días, " + horas +" horas, y "+  minutos + " minutos";
            }
          }

          this.getUsuarios(this.tickets)
          this.cargar = false

        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      verMotivo(value){
        this.ticket = value
        this.dialog = true
      },

      save () {
        this.ticket.id_area     = this.puesto.idpuesto
        this.ticket.idjefe_area = this.jefe.id_usuario
        this.ticket.estatus     = 2

        this.$http.put('tickets.update.asignacion/'+this.ticket.idticket, this.ticket).then(response=>{
          this.dialog = false
          this.jefe   = null
          this.puesto = null
          this.area   = null
          this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getColor (estatus) {
        if (estatus == 3) return 'red'
        else if (estatus == 1) return 'orange'
        else if (estatus == 2) return 'blue'
      },

      historialTicket(value){
        this.ticket = value
        this.historial = []
        this.$http.get('historial_tickets.estatus/'+this.ticket.idticket).then(response=>{
          this.historial = response.body
          console.log( this.historial )
          this.dialogHistorial = true
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
        this.ver = false
      },

      abrirRechazar( ){
        this.historial = []
        this.$http.get('historial_tickets.estatus/'+this.ticket.idticket).then(response=>{
          this.historial = response.body
          this.dialogResponder = true
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
        this.ver = false
      },

      exportar(){


        let data = this.filterTickets.map(({ idticket, estatus, motivo, plantel, nombre_jefe, nombre_auxiliar, fecha_apertura }) => ({ idticket, estatus, motivo, plantel, nombre_jefe, nombre_auxiliar, fecha_apertura }));

        for( const i in data ){
          const { estatus } = data[i]

          switch( estatus ){

            case 1:
              data[i].estatus = "Abierto"
            break; 

            case 2:
              data[i].estatus = "Asignado"
            break; 

            case 3:
              data[i].estatus = "Pendiente"
            break; 

            case 4:
              data[i].estatus = "Revisión"
            break; 

            case 5:
              data[i].estatus = "Respondido"
            break; 

            case 6:
              data[i].estatus = "Cerrado"
            break; 

            case 7:
              data[i].estatus = "Rechazado"
            break; 

          }
        }

        this.exportExcel( data, 'tickets_list')
      },

      saveRespuesta (respuestas) {
        var payload = {
          idhistorial_ticket : respuestas.idhistorial_ticket,
          motivo             : this.ticket.motivo,
          respuestaauxi      : this.respuesta,
          respuesta          : this.respuesta,
          idticket           : this.ticket.idticket,
          estatus            : 0
        }
        var estatus = { estatus: 5 }

        this.$http.put('historial_tickets.update/' + respuestas.idhistorial_ticket, payload).then(response=>{
          this.$http.put('tickets.update.estatus/' + this.ticket.idticket,estatus).then(response=>{
            this.mensaje         = ''
            this.respuesta       = ''
            this.dialog          = false
            this.dialogRechazo   = false
            this.dialogResponder = false
            this.initialize()
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getUsuarios (value) {
        this.$http.get('usuarios.all.erp').then(response=>{
          this.usuariosTickets = response.body
        }).catch(error=>{console.log(error)})
      },


      updateVisorRh( item ){
        this.cargar = true
        this.$http.post('tickets.update.visorrh', item).then(response=>{
          this.cargar = false
          this.validarSuccess( response.body.message )
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      }
    },
  }
</script>
<style>
  .v-data-table__wrapper{

  }

  .v-data-table__wrapper::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-data-table__wrapper::-webkit-scrollbar:vertical {
    width: 10px !important;
  }

  .v-data-table__wrapper::-webkit-scrollbar:vertical{
    width: 10px !important;
  }

  .v-data-table__wrapper::-webkit-scrollbar-button:increment,.v-data-table__wrapper::-webkit-scrollbar-button{
    display: none;
  }

  .v-data-table__wrapper::-webkit-scrollbar:horizontal{
    height: 10px !important;
  }

  .v-data-table__wrapper::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }


</style>